import React, { Fragment, useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { Card, CardBody, Container, Row } from "reactstrap";
import { ToastContainer } from "react-toastify";

import { makeStyles } from "@mui/styles";
import CommonTable from "../../common/commonTable";
import {
  autoImportLogTableData,
  autoImportLogTableHeader,
} from "../../common/commonConstant";
import { useEffect } from "react";
import { getAutoImportLogDetails } from "../../api/service";
import CommonLoader from "../../common/commonLoader";

const useStyles = makeStyles((theme) => ({
  cardbody: {
    padding: `${theme.spacing(1.8, 1.3)} !important`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(0)} !important`,
      margin: `${theme.spacing(0, 1)} !important`,
    },
  },
}));

const AutoImportLogs = () => {
  const classes = useStyles();

  const [page, setPage] = React.useState(0);
  const [totalRecord, setTotalRecord] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    loadListData();
  }, []);

  const loadListData = () => {
    setLoading(true);
    getAutoImportLogDetails(page, rowsPerPage).then((res) => {
      setLoading(false);
      setData(res.response.responseObject);
      setTotalRecord(res.response.responseMap.totalCount);
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setLoading(true);
    getAutoImportLogDetails(newPage, rowsPerPage).then((res) => {
      setLoading(false);
      setData(res.response.responseObject);
      setTotalRecord(res.response.responseMap.totalCount);
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
    setLoading(true);
    getAutoImportLogDetails(0, event.target.value).then((res) => {
      setLoading(false);
      setData(res.response.responseObject);
      setTotalRecord(res.response.responseMap.totalCount);
    });
  };

  return (
    <Fragment>
      <Breadcrumb title="Auto Import Logs" />
      {loading ? <CommonLoader /> : null}
      {/* <!-- Container-fluid starts--> */}
      <Container fluid={true}>
        <Row>
          <Card>
            <CardBody className={classes.cardbody}>
              <div>
                <CommonTable
                  tableData={data}
                  tableHeaders={autoImportLogTableHeader}
                  tableColumns={autoImportLogTableData}
                  editId={"autoImportLogId"}
                  editMode={false}
                  rowsPerPageOptions={[25, 50, 100]}
                  count={totalRecord}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{ float: "right" }}
                  showTimeStamp
                />
              </div>
            </CardBody>
          </Card>
        </Row>
      </Container>
      {/* <!-- Container-fluid Ends--> */}
      <ToastContainer autoClose={1000} />
    </Fragment>
  );
};

export default AutoImportLogs;
